const ua = window.navigator.userAgent
const msie = ua.indexOf('MSIE ')
let ieVersion = 0

if (msie > 0) {
  ieVersion = parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
}

export default {
  isIE9or10: (msie > 0),
  isIE9: ieVersion === 9,
  isIE10: ieVersion === 10
}
